import type { Epic } from '../../index.js'
import { catchError, debounceTime, defer, filter, map, of, switchMap, takeUntil } from 'rxjs'
import { otuSlice } from '../../Slice/Otu/OtuSlice.js'

export const FetchInitialEpic: Epic = (action$, state$, { OtuRepository, [otuSlice.name]: otu }) =>
  action$.pipe(
    filter(otu.fetchInitial.match),
    debounceTime(300),
    // catchError stays inside the switchMap — on the outer stream one failure completes the epic for good.
    // `defer` puts the request construction inside it too, so a synchronous throw is caught as well.
    switchMap((action) =>
      defer(() =>
        OtuRepository.autocompleteOrder({
          orderId: action.payload.orderId,
          projectId: action.payload.projectId,
          query: action.payload.query,
          field: action.payload.field,
          page: 0,
          blastType: action.payload.blastType
        })
      ).pipe(
        takeUntil(action$.pipe(filter(otu.fetchInitial.match))),
        map((response) => otu.fetchInitialSuccess(response)),
        catchError((error) => of(otu.fetchInitialFailure(error)))
      )
    )
  )
